import EditorServices from './services';
export default function(data) {
  var self = this;
  self.element = $('#instructors');
  self.instructors = ko.observableArray();
  self.server_errors = ko.observableArray();
  self.current_user = ko.observable();

  self.initUI = function() {
    EditorServices.initDropZones(self.element, self.instructors);
  };

  self.bindData = function(data) {
    self.instructors = ko.mapping.fromJSON(data[0]);
    self.current_user = ko.mapping.fromJSON(data[1]);
    _.each(self.instructors(), function(instructor, idx) {
      if (instructor.enrollment) {
        instructor.enrollment.hide_from_syllabus.subscribe(function(newVal) {
          self.saveEnrollment(instructor.enrollment, newVal);
        });
      }
    });
  };

  self.saveEnrollment = function(enrollment, newVal) {
    let url = Kadenze.Routes.update_enrollment_course_instructor_path(enrollment.enrollable_id(), enrollment.user_id());
    var request = new Kadenze.AjaxRequest({
      url: url,
      type: 'PATCH',
      data: {
        instructor: {
          hide_from_syllabus: newVal
        }
      }
    });
  };

  self.saveInstructor = function(item, event) {
    var index = self.instructors().indexOf(item);
    var model = ko.toJS(item);
    var $target = $(event.currentTarget);
    var $editor = $target.parent().parent();

    model.social_info_attributes = model.social_info;
    delete model.institutions;
    delete model.social_info;

    var data = {instructor: model};
    var url = window.location.pathname + '/' + item.id();
    var method = 'PUT';

    self.client_errors = ko.validation.group(self.instructors()[index], { deep: true });

    if (self.client_errors().length === 0) {
      Kadenze.UIUtil.makeRequest(url, method, data, $editor, null, function(data, textStatus, xhr) {
        EditorServices.hideEditor($target);
        self.server_errors([]);
        var instructor = ko.mapping.fromJS(data);
        EditorServices.updateCollection(self.instructors, instructor);
      }, function(data) {
        self.server_errors(data.responseJSON.instructors);
      });
    } else {
      self.client_errors.showAllMessages();
    }
  };

  const __construct = function(that) {
    console.log('constructor called for CourseInstructorEditViewModel');
    that.bindData(data);
  }(this);
}
